import {gql} from "@apollo/client";

export const UPDATE_APPOINTMENT_NOTES = gql`
    mutation UpdateAppointmentNotes($appointmentId: Long!, $notes: String) {
        updateAppointmentNotes(appointmentId: $appointmentId, notes: $notes)
    }
`;

export interface UpdateAppointmentNotesResponse {
    updateAppointmentNotes: boolean;
}

